import { getStyledTextUsedFonts } from '@wix/thunderbolt-becky-root'
import type { Component, WRichTextDefinition } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { isRichTextComponent, isStyledText } from '../../../utils/is'
import type { FeatureRefs } from '../../cssFeatures.types'

export const richTextFontFamilies = {
	predicate: (component: Component) => isRichTextComponent(component),
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) =>
			refs.dataQuery<WRichTextDefinition['data']>(component.dataQuery!),
		toViewItem: (__, compData) =>
			isStyledText(compData)
				? getStyledTextUsedFonts(compData).fontFamilies.flatMap((x) => x.split(','))
				: EMPTY_ARRAY,
	}),
}
